<template>
    <!--
        B2.1B - stato di BLOCCO, unico percorso per i tre casi che NON sono dati:
        loading / non disponibile (null) / errore.
        Serve a garantire che un blocco assente non venga mai letto come 0 o come
        "nessun dato": la differenza e' sempre visibile all'utente.
    -->
    <div class="card" :class="cardClass" role="status" :aria-live="polite ? 'polite' : 'off'">
        <div class="card-body text-center py-4" v-if="stato === 'loading'">
            <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
            <p class="text-muted mt-2 mb-0 small">{{ messaggioLoading }}</p>
        </div>

        <div class="card-body text-center py-4" v-else-if="stato === 'non_disponibile'">
            <i class="ph ph-info-circle text-muted fs-3" aria-hidden="true"></i>
            <p class="text-muted mt-2 mb-0">
                <strong>Dati non disponibili.</strong>
            </p>
            <p class="text-muted small mt-1 mb-0" v-if="dettaglio">{{ dettaglio }}</p>
        </div>

        <div class="card-body text-center py-4" v-else-if="stato === 'errore'">
            <i class="ph ph-warning text-danger fs-3" aria-hidden="true"></i>
            <p class="text-danger mt-2 mb-1"><strong>Errore nel caricamento dei dati.</strong></p>
            <p class="text-muted small mt-1 mb-3" v-if="dettaglio">{{ dettaglio }}</p>
            <button type="button" class="btn btn-sm btn-outline-primary" v-if="mostraRiprova" @click="$emit('riprova')">
                <i class="ph ph-arrow-clockwise me-1" aria-hidden="true"></i>Riprova
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "BlockState",

    props: {
        /* 'loading' | 'non_disponibile' | 'errore' */
        stato: { type: String, required: true },
        dettaglio: { type: String, default: "" },
        messaggioLoading: { type: String, default: "Caricamento..." },
        mostraRiprova: { type: Boolean, default: false },
        cardClass: { type: String, default: "" },
        polite: { type: Boolean, default: true },
    },

    emits: ["riprova"],
}
</script>
